import { shebaNumberService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    sheba_numbers: [],
    iban_list: [],
    bankAccounts: {
        cardNumber: {},
        accountNumber: {}
    }
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, sheba_numbers) {
        state.status    = 'success'
        state.sheba_numbers = sheba_numbers
    },
    ibanList(state, iban_list) {
        state.status    = 'success'
        state.iban_list = iban_list
    },
    successBankAccount(state, bankAccounts) {
        state.status = 'success'
        state.bankAccounts = bankAccounts
    },
    fail(state) {
        state.status    = 'fail'
        state.sheba_numbers = []
    },
}

const getters = {
    status: state => state.status,
    sheba_numbers: state => state.sheba_numbers,
    iban_list: state => state.iban_list,
    bankAccounts: state => state.bankAccounts
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return shebaNumberService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },
    fetchBankAccount({commit}) {
        commit('loading')
        return shebaNumberService.fetchBankAccount().then(response => {
            commit('successBankAccount', response.data.data)
        })
    },
    fetchByShopId({commit}, {params, is_starshop= false}) {
        commit('loading')
        return shebaNumberService.fetchByShopId(params, is_starshop).then(response => {
            commit('success', response.data.data)
        })
    },
    fetchList({commit}, {params, is_starshop = false}) {
        commit('loading')
        return shebaNumberService.fetchList(params, is_starshop).then(response => {
            commit('ibanList', response.data.data)
        })
    },
    createSheba({commit},params){
        return shebaNumberService.createShebaNumber(params)
    },
    deleteShebaNumber({commit},params) {
        return shebaNumberService.deleteShebaNumber(params)
    },
    updateSheba({commit},params){
        return shebaNumberService.updateShebaNumber(params)
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}